import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { parseNumber } from 'devextreme/localization';
import { AlertService } from 'src/app/core/alert.service';
import { OptionsSource } from 'src/app/core/core.models';
import { LoadingService } from 'src/app/core/loading.service';
import { UtilityService } from 'src/app/core/utility.service';
import { OfferedProduct } from '../../offered-products/offered-products.models';
import { OfferedProductsService } from '../../offered-products/offered-products.service';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { CustomerOrderProduct } from '../customer-orders.models';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { CustomerOrdersService } from '../customer-orders.service';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { RequestService } from 'src/app/core/request.service';
import { RouteAuthorities } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';

@Component({
  selector: 'app-customer-order-products-list',
  templateUrl: './customer-order-products-list.component.html',
  styleUrls: ['./customer-order-products-list.component.scss']
})
export class CustomerOrderProductsListComponent extends BaseListComponent implements OnInit{
  @Output() forcePendingChanges = new EventEmitter();
  @Output() updateCosts = new EventEmitter();
  @ViewChild('grid') grid: DxDataGridComponent;
  @Input('customerOrderProducts') customerOrderProducts: CustomerOrderProduct[];
  @Input('pointOfSale') pointOfSale: PointOfSale;

  public gridStateKey: string = 'customer_order_products_list';
  public lookupColumns: Array<string> = [ 'offeredProduct', 'orderedQuantity', 'approvedQuantity', 'offeredProduct.quantityAvailable', "regularPrice", "salePrice", "rebatePercentage", "invoicePrice", "finalAmountTemplate" ];
    
  public productFormCaption: string;
  public productFormSubmitCaption: string;
  public productFormSubmitIcon: string;
  public isCustomerOrderProductFormVisible: boolean = false;
  public selectedProduct: OfferedProduct;
  public offeredProducts: OptionsSource;

  // constructor(
  //   private translateService: TranslateService, 
  //   private alertService: AlertService,
  //   public loadingService: LoadingService,
  //   private offeredProductsService: OfferedProductsService,
  //   public utilityService: UtilityService
  // ) { }

  constructor(
    private offeredProductsService: OfferedProductsService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'CUD_B2B_ORDR', 'R_B2B_ORDR', 'CUD_B2B_ORDR', 'CUD_B2B_ORDR');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
   }

  ngOnInit(){
  }

  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }
  
  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  ngOnChanges(changes: SimpleChanges) {
      if(changes.pointOfSale.currentValue) {
        this.offeredProducts = this.offeredProductsService.getOfferedProductsOptionsByPointOfSale(this.pointOfSale.id);        
      }

      if(changes.customerOrderProducts.currentValue) {
        let productIds = [];
        this.customerOrderProducts.forEach(p => productIds.push((<OfferedProduct>p.offeredProduct).id));

        this.offeredProductsService.getAvailableQuantityForProductsByPOS(this.pointOfSale.id, productIds, (res: OfferedProduct[])=> {
          for(let cp of this.customerOrderProducts)
            for(let op of res) 
              if((<OfferedProduct>cp.offeredProduct).id == op.id) 
                (<OfferedProduct>cp.offeredProduct).quantityAvailable = op.quantityAvailable;
        });
      }
  }

  public onEditorPreparingProducts($event: any): void {
    $event.editorOptions.onValueChanged = (event: any) => {
      let row = $event.row.rowIndex;

      let customerOrderProduct: CustomerOrderProduct = $event.row.data;
      if (customerOrderProduct != null) {
        if ($event.dataField == 'approvedQuantity') {
          $event.component.cellValue(row, 'approvedQuantity', event.value)
        }
        else if ($event.dataField == 'salePrice') {
          $event.component.cellValue(row, 'salePrice', event.value);
          $event.component.cellValue(row, 'invoicePrice', parseNumber(
            (event.value - (event.value * customerOrderProduct.rebatePercentage / 100)).toFixed(2)
            , '#.00'));
        }
        else if ($event.dataField == 'rebatePercentage') {
          let inputRebate: number = event.value;
          let newInvoice: number = Math.floor((customerOrderProduct.salePrice - (customerOrderProduct.salePrice * inputRebate / 100)) * 100) / 100;
          let newRebate: number = (customerOrderProduct.salePrice - newInvoice) / customerOrderProduct.salePrice * 100;

          $event.component.cellValue(row, 'rebatePercentage', newRebate );
          $event.component.cellValue(row, 'invoicePrice', (customerOrderProduct.salePrice - (customerOrderProduct.salePrice * newRebate / 100)));
        }
        else if ($event.dataField == 'invoicePrice') {
          let inputPrice: number = event.value;
          let rebate: number = (customerOrderProduct.salePrice - inputPrice) / customerOrderProduct.salePrice * 100;
          $event.component.cellValue(row, 'rebatePercentage', rebate );
          $event.component.cellValue(row, 'invoicePrice', inputPrice);
        }
        this.grid.instance.saveEditData();
        this.updateCosts.emit();
        this.forcePendingChanges.emit();
      }
    }
  }

  public onToolbarPreparingProducts(event) {
    event.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
        onClick: this.openAddCustomerOrderProductForm.bind(this)
      },
      locateInMenu: 'auto'
    });
  }

  public openAddCustomerOrderProductForm() {
    this.productFormCaption = 'SHARED.ADD_ITEM';
    this.productFormSubmitCaption = 'DEV-EXTREME.dxDataGrid-editingAddRow';
    this.productFormSubmitIcon = 'add';
    this.isCustomerOrderProductFormVisible = true;
  }

  public saveProduct() {
    let productExists: boolean = false;
    for (let cop of this.customerOrderProducts) {
      let copProduct = <OfferedProduct>cop.offeredProduct;
      let selProduct = <OfferedProduct>this.selectedProduct;
      if (copProduct.id == selProduct.id) {
        productExists = true;
        break;
      }
    }

    if (productExists) {
      this.alertService.error('CUSTOMER_ORDERS.PRODUCT_UNIQUE');
      return;
    }

    let customerOrderProduct: CustomerOrderProduct = new CustomerOrderProduct(this.selectedProduct);
    this.customerOrderProducts.push(customerOrderProduct);
    this.closeCustomerOrderProductForm();
    this.updateCosts.emit();
    this.forcePendingChanges.emit();
  }

  public closeCustomerOrderProductForm() {
    this.selectedProduct = null;
    this.isCustomerOrderProductFormVisible = false;
  }

  
  calculateDisplayValueRebatePercentage = (event) => {
    return Math.floor(event.rebatePercentage * 100) / 100;
  }

}
